Pixlee.module('SocialAuthApp', function(SocialAuthApp, App, Backbone, Marionette, $) {
    var _this = this,
        API;

    SocialAuthApp.on("start", function(options) {
        new SocialAuthApp.Show.Controller(options);
    });
});